<template>
  <div class="form-frame-module" :style="{ 'width': moduleWidth }" :class="cssObj[0]">
    <div class="form-frame-left" :style="{ 'width': leftWidth }" :class="cssObj[1]">
      <slot name="leftInfo"></slot>
    </div>
    <div class="form-frame-right" :style="{ 'justify-content': js ? js : 'flex-start' }" :class="cssObj[2]">
      <slot name="rightInfo"></slot>
    </div>
  </div>
</template>

<script>
//此组件外层需要套个div，此div的class=form-frame
/*
moduleWidth:左框宽度
leftWidth:右框宽度
计算宽度函数（用于含有图片的数据）
cssObj:[] 支持按需修改style
用于动态计算表格宽度，放在父组件中（moduleWidth，leftWidth使用）
data = {
      label: '学生信息',//标题名
      value: [
        {
          label: '姓名',
          value: '张三',
          dataType: 'text',//文字内容
        },
        {
          label: '姓名',
          value: ['https://.......img.png'],
          dataType: 'img',//图片内容（图片要放到数组最后一位，若有多张图片请处理到一起）
        }
      ],//表格内容
      imgTag:true,//是否有图片
      objectType: 'show',//表格展示
    },
countWidth(index, data, type) {
      let persent = function (flag, types) {
        if (flag) {
          if (types == 'module') {
            return '100%'
          } else {
            return '15%'
          }
        } else {
          if (types == 'module') {
            return '50%'
          } else {
            return '30%'
          }
        }
      }
      if (data.imgTag) {
        let imgIndex = data.value.findIndex(function (item) {
          return item.dataType == 'img'
        })
        console.log('imgIndex:', imgIndex, index)
        if (index == imgIndex - 1 || index >= imgIndex) {
          return persent(true, type)
        } else {
          return persent(false, type)
        }
      } else {
        if (data.value.length % 2 == 1 && index == data.value.length - 1) {
          return persent(true, type)
        } else {
          return persent(false, type)
        }
      }
    },
*/
export default {
  props: {
    js: {
      type: String,
      default: '',
    }, //横向对齐方式
    moduleWidth: {
      type: String,
      default: '100%',
    }, //每行宽度
    leftWidth: {
      type: String,
      default: '30%',
    }, //每行宽度
    cssObj: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>

<style lang="less" scoped>
.form-frame-module {
  width: 100%;
  min-height: 50px;
  display: flex;

  .form-frame-left {
    height: 100%;
    width: 30%;
    flex-shrink: 0;
    border-right: 1px solid #d0d0d0;
    border-bottom: 1px solid #d0d0d0;
    background: #f5f5f5;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #848484;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-flow: wrap;
    padding: 10px;
  }

  .form-frame-right {
    height: 100%;
    flex: 1;
    flex-shrink: 0;
    border-right: 1px solid #d0d0d0;
    border-bottom: 1px solid #d0d0d0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    flex-flow: wrap;
    padding: 10px;
    word-break: break-all;
    word-wrap: break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-form-frame-single.vue